import { Component, OnInit, } from '@angular/core';
import { I18nService } from '@app/services/i18n/i18n.service';
import { TourGuideContent } from '@app/util/tour-guide-content.util';

@Component({
  selector: 'app-guided-tour',
  templateUrl: './guided-tour.component.html',
  styleUrls: ['./guided-tour.component.scss']
})

export class GuidedTourComponent implements OnInit {

  /**
   * Constructor
   * @param i18nservice 
   */
  constructor(private i18nservice: I18nService) { }
  /** Buttons content has been defined and its dynamically passing from tourguidecontent.util file */
  PreviousbuttonContent = this.i18nservice.getString(TourGuideContent.buttons.previous)
  NextbuttonContent = this.i18nservice.getString(TourGuideContent.buttons.next)
  SkipbuttonContent = this.i18nservice.getString(TourGuideContent.buttons.skip)

  /** ngOnInit */
  ngOnInit() {
  }
}
